import { Drawer, Box } from '@mui/material'

const ChatPanel = ({ open, onClose, children }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 600 },
          maxWidth: '100vw',
          borderRadius: { xs: 0, sm: '12px 0 0 12px' },
        },
      }}
      ModalProps={{ keepMounted: true }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {children}
      </Box>
    </Drawer>
  )
}

export default ChatPanel
